import LocalStorage from './Local';

export { LocalStorage };

export default class ProxyStorage {
	constructor() {
		throw new Error('this class can\'t be an instance');
	}

	static get(key) {
		return LocalStorage.get(key);
	}

	static set(key, value) {
		LocalStorage.set(key, value);
	}

	static remove(key) {
		LocalStorage.remove(key);
	}

	static clear(){
		LocalStorage.clear();
	}
}